import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { CardService } from 'src/app/services/api/card.service';
import { ChatEntity } from 'src/app/models/entities/chat.entity';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-speech-bubble',
    imports: [CommonModule, MatIconModule, PipesModule, MatTooltipModule, RouterModule],
    templateUrl: './speech-bubble.component.html',
    styleUrls: ['./speech-bubble.component.scss']
})
export class SpeechBubbleComponent {
  @Input() public right: boolean = false;
  @Input() public reply: boolean = false;
  @Input() public bubbleInBubble: boolean = false;
  @Input() public embedded: boolean = false;
  @Input() public chat!: ChatEntity;
  @Input() public cardLane: string | null = null; // Now passed from parent

  @Output()
  public deleted: EventEmitter<any> = new EventEmitter();

  @Output()
  public replyClicked: EventEmitter<any> = new EventEmitter();

  @Output()
  public close: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) {}

  public navigateToCard() {
    const boardKey = this.chat.boardKey;
    const cardKey = this.chat.cardKey || this.chat.card;
    
    if (boardKey && cardKey) {
      this.router.navigate(['/board', boardKey, cardKey]);
    }
  }

  public delete() {
    
    this.deleted.emit();
  }

  public isImageUrl(url: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];

    const fileName = this.extractFileName(url);
    // Extract the file extension from the URL
    const extension = fileName
      .substring(fileName.lastIndexOf('.'))
      .toLowerCase();

    // Check if the extension matches the image extensions
    return imageExtensions.includes(extension);
  }

  public extractFileName(url: string): string {
    const startIndex = url.lastIndexOf('/') + 1;
    const endIndex = url.indexOf('?') !== -1 ? url.indexOf('?') : undefined;
    const fileName = url.substring(startIndex, endIndex);
    return decodeURIComponent(fileName);
  }
}
